import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useThreadMessages } from '@dialectlabs/react-sdk';
import React, { useEffect } from 'react';
import { Divider } from '../../../common';
import { useTheme } from '../../../common/providers/DialectThemeProvider';
import { useRoute } from '../../../common/providers/Router';
import NoNotifications from '../../../../entities/notifications/NoNotifications';
import { Notification } from '../../../../entities/notifications/Notification';
const NotificationsListWrapper = (props) => {
    const { params: { threadId }, } = useRoute();
    if (!threadId) {
        return null;
    }
    return _jsx(NotificationsList, { ...props });
};
const NotificationsList = ({ refreshInterval }) => {
    const { notificationsDivider } = useTheme();
    const { params: { threadId }, } = useRoute();
    const { messages, markAsRead } = useThreadMessages({
        id: threadId,
        refreshInterval,
    });
    useEffect(() => {
        markAsRead();
    }, [markAsRead]);
    if (!messages.length) {
        return _jsx(NoNotifications, {});
    }
    return (_jsx("div", { className: "dt-py-4", children: messages.map((message, idx) => (_jsxs(React.Fragment, { children: [_jsx(Notification, { message: message.text, timestamp: message.timestamp.getTime() }), _jsx(Divider, { className: notificationsDivider })] }, idx))) }));
};
export default NotificationsListWrapper;
//# sourceMappingURL=index.js.map